<template>
  <section class="section">
    <span class="back" @click="$router.back()">
      <i class="fal fa-chevron-left"></i>
    </span>

    <div class="page-header">
      <h3 class="page-title" v-if="($route.query.id = $route.query.id)">
        Update Article
      </h3>

      <h3 class="page-title" v-else>Add Article</h3>
    </div>

    <div class="box">
      <ValidationObserver ref="refForm" v-slot="{ handleSubmit }">
        <div class="article-image" @click="chooseImage">
          <!-- :style="{ 'background-image': `url( ${imageData} )` }" -->

          <img :src="imageData" alt="" />

          <div class="upload-btn">
            <input
              class="file-input is-focused"
              name="Image"
              ref="fileinput"
              type="file"
              @input="onSelectFile"
            />

            <i class="fas fa-camera"></i>
          </div>
        </div>

        <div class="container has-text-centered" v-if="!$route.query.id">
          <ValidationProvider
            name="image"
            rules="required|image"
            v-slot="{ errors }"
          >
            <input type="text" style="display: none" v-model="form.file" />

            <span style="color: red; font-size: 12px">{{ errors[0] }}</span>
          </ValidationProvider>
        </div>

        <div class="container has-text-centered" v-if="selectFiles == true">
          <span style="font-size: 14px">{{ errorfileSize }}</span>
        </div>

        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="field">
              <label for="" class="label">Article Type</label>

              <div class="control">
                <selection
                  v-model="form.articleType"
                  :data="article"
                  name="Article Type"
                  :selection="clickArticle"
                  :updateText="selectArticles"
                />

                <br />
              </div>
            </div>
          </div>

          <div class="column is-6">
            <div class="field">
              <label for="" class="label">Publish Date</label>

              <div class="control">
                <input type="date" v-model="form.openingDate" class="input" />
              </div>
            </div>
          </div>

          <div class="column is-6">
            <div class="field">
              <label for="" class="label">Unpublish Date</label>

              <div class="control">
                <input type="date" v-model="form.closingDate" class="input" />
              </div>
            </div>
          </div>

          <div class="column is-12">
            <div class="field">
              <label for="" class="label">Article Title</label>

              <div class="control">
                <ValidationProvider
                  name="title"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    class="input"
                    v-model="form.title"
                    :class="{ error: errors[0] }"
                    placeholder="Title...."
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="column is-12">
            <div class="field">
              <label class="label">Description</label>

              <div class="control">
                <ValidationProvider
                  name="description"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div v-if="!isLoading">
                    <FroalaEditor v-model="form.description" />
                  </div>

                  <FroalaEditor v-if="isLoading" v-model="form.description" />

                  <span style="color: red; font-size: 12px">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>

        <button
          class="button is-primary"
          @click="handleSubmit(update)"
          v-if="($route.query.id = $route.query.id)"
        >
          Update
        </button>

        <!--  <button class="button is-primary" @click="handleSubmit(save)" v-else>Save</button> -->

        <button class="button is-primary" @click="save()" v-else>Save</button>
      </ValidationObserver>
    </div>

    <!-- box -->
  </section>
</template>

<script>
import { GET_REUSE } from "@/graphql/manage/query";
import {
  ADD_ARTICLE,
  SEARCH_ARTICLE,
  UPDATE_ARTICLE,
} from "@/graphql/articles/articles";
import selection from "../others/selection";
import FroalaEditor from "../others/FroalaEditor";
import axios from "axios";
import moment from "moment";
import { apolloClient } from "@/services/apollo-client";
export default {
  components: { FroalaEditor, selection },

  data: () => ({
    isLoading: true,
    clickArticle: false,
    selectArticles: [],
    result: [],
    article: [],
    errorfileSize: "",
    imageData: null,
    selectFiles: false,

    form: {
      file: {},
      articleType: [],
      title: "",
      description: "",
      closingDate: "",
      openingDate: "",
    },
  }),
  computed: {
    getArticleType() {
      const filter = this.article.filter((i) => {
        return this.form.articleType.includes(i._id);
      });
      const mappers = filter.map((i) => i.name);
      return mappers;
    },
  },
  methods: {
    chooseArticle() {
      this.clickArticle = !this.clickArticle;
      this.form.articleType = this.selectArticles;
    },
    chooseImage() {
      this.$refs.fileinput.click();
    },

    async onSelectFile() {
      this.selectFiles = true;
      const input = this.$refs.fileinput;
      const files = input.files;

      const file = files[0];
      // console.log(size, "MB")

      const formData = new FormData();

      formData.append("file", file);
      // console.log(formData)
      if (file) {
        const filesize = file.size / 1024;
        // console.log(filesize, "KB")
        const size = 5 * 1024;
        if (filesize < size) {
          // this.errorfileSize = file.name
          axios.defaults.headers.common["Authorization"] =
            this.$store.getters.Token;
          const res = await axios.post(`${this.$urlImageFile}`, formData);
          if (res.data.message) {
            this.errorfileSize = "The file must be .JPG, .PNG. JPEG, .SVG";
            this.form.file = null;
            this.imageData = null;
          }
          if (res.data.file) {
            this.errorfileSize = file.name;
            this.form.file = res.data.file;
            if (files && files[0]) {
              const reader = new FileReader();
              reader.onload = (e) => {
                this.imageData = e.target.result;
              };
              reader.readAsDataURL(files[0]);
              this.$emit("input is-focused", files[0]);
            }
          }
          // console.log(res.data.file.size)
        } else {
          this.errorfileSize = "The file Size is too much";
          this.imageData = null;
        }
      }
    },
    async save() {
      // save banner
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      await apolloClient.mutate({
        mutation: ADD_ARTICLE,
        variables: {
          title: this.form.title,
          file: this.form.file,
          detail: this.form.description,
          BlogTypeId: this.form.articleType,
          closingDate: this.form.closingDate,
          openingDate: this.form.openingDate,
        },
      });

      this.$router.back();
      //    const object={ title: this.form.title,
      //              file: this.form.file,
      //             detail: this.form.description,
      //             BlogTypeId: this.form.articleType,
      //            closingDate: this.form.closingDate,
      //            openingDate: '',}
      // console.log( object)
    },

    async getArticle() {
      //console.log(this.funcs)
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          name: this.banner,
          type: "BlogType",
          page: 1,
          perPage: 100,
        },
      });

      this.article = res.data.getReuse.reuseType;
    },
    async getData() {
      if (this.$route.query.id) {
        const res = await apolloClient.query({
          query: SEARCH_ARTICLE,
          variables: {
            id: this.$route.query.id,
          },
        });
        this.isLoading = false;
        this.result = res.data.findBlog;
        this.imageData = this.result.FileId.src;
        this.form.articleType = this.result.BlogTypeId.map((i) => i._id);
        this.selectArticles = this.result.BlogTypeId.map((i) => i._id);
        this.form.title = this.result.title;
        this.form.description = this.result.detail;
        this.form.closingDate = moment(this.result.closingDate).format(
          "YYYY-MM-DD"
        );
        this.form.openingDate = moment(this.result.openingDate).format(
          "YYYY-MM-DD"
        );
        this.$refs.editor.form = {
          info: this.result.detail,
        };
      }
    },
    async update() {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      // save banner
      await apolloClient.mutate({
        mutation: UPDATE_ARTICLE,
        variables: {
          blogId: this.$route.query.id,
          title: this.form.title,
          file: this.form.file,
          detail: this.form.description,
          BlogTypeId: this.form.articleType,
          closingDate: this.form.closingDate,
          openingDate: this.form.openingDate,
        },
      });
      this.$router.back();
    },
  },
  created() {
    this.getData();
    this.getArticle();
  },
};
</script>

<style lang="scss" scoped>
.file {
  display: flex;
}
.banner {
  cursor: pointer;
  display: block;
  max-height: 100%;
}
.article-image {
  background-color: var(--light-grey-color);
  position: relative;
  cursor: pointer;
  margin: 0 auto;
  width: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center center;
  padding: 20px;
  border: 1px solid var(--border-color);
  margin-bottom: 30px;
  &:hover .upload-btn {
    opacity: 1;
  }
  img {
    display: block;
  }
  .upload-btn {
    transition: opacity 0.3s;
    opacity: 0;

    background-color: rgba(#333, 0.1);
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    i {
      padding: 5px;
      font-size: 20px;
    }
  }
} // logo
.label {
  margin-top: 10px;
}
.file-input is-focused {
  display: none;
}
.control {
  .select-label {
    position: absolute;
    width: 46%;
    cursor: pointer;
    margin: 0;
    padding: 9px;
    z-index: 999;
    font-size: 16px;
    transition: all ease-in-out 0.2s;
    font-weight: 500;
    .placeholder {
      color: var(--primary-color);
    }
    .select-box {
      z-index: 1;
      position: relative;
      padding-top: 12px;
      width: 100%;
      border-radius: 5px;
      background-color: var(--sub-color);
      box-shadow: 0 0px 20px 5px rgba(var(--grey-color), 0.5);
      top: -5px;
      position: absolute;
      .close-btn {
        margin-left: auto;
        cursor: pointer;
      }
      .select-box-title {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        &:hover {
          color: inherit;
        }
      }
      .select {
        padding: 10px 20px 20px;
        input {
          background-color: var(--light-grey-color);
          box-shadow: none;
          box-shadow: unset;
          border: none;
          box-shadow: 0px 0px 0px 2px rgba(var(--primary-color), 1);
        }
      }
      .select-list {
        border-radius: 5px;
        background-color: #fff;
        padding: 20px;
        padding: 0;
        display: block;
        height: 200px;
        overflow-y: scroll;
        .select-item {
          font-size: 14px;
          white-space: pre-line;
          margin: 0;
          padding: 10px 20px;
          transition: all ease-in-out 0.1s;
          cursor: pointer;
          &:not(:last-child) {
            border-bottom: 1px solid var(--border-color);
          }
          &:hover {
            background-color: #dbdbdb;
          }
          p {
            margin: 0;
          }
        }
      }
    } // search-box
  }
}

.error {
  border: 2px solid rgb(255, 86, 8);
  color: rgb(255, 80, 15);
}
</style>
